export default "__VITE_ASSET__6bcf28a4__"